import React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import ReduxForm from '../../../components/UI/Form/ReduxForm'
import { useSelector } from 'react-redux';

import Modal from '../../../components/UI/Modal/Modal';
import API from '../../../lib/api';

import { getAuthToken, isFirstLogin, clearFirstLogin } from '../../../components/util/auth';

import FormGenerator from '../../../components/UI/Form/FormGenerator/FormGenerator';

const formLabel = 'profile';

export const theForm = {
  name: {
    tag: 'input',
    label: 'Name',
    attributes: {
      type: 'text',
      placeholder: 'Name',
      style: {width: '300px'}
    },        
    errorMessage: 'Bitte Namen eingeben'
  },
  first_name: {
    tag: 'input',
    label: 'Vorname',
    attributes: {
      type: 'text',
      placeholder: 'Vorname',
      style: {width: '300px'}
    },
    errorMessage: 'Bitte Vornamen eingeben'
  },
  XlineBreakA: {},
  address: {
    tag: 'input',
    label: 'Adresse',
    attributes: {
      type: 'text',
      placeholder: 'Adresse',
      style: {width: '300px'}
    },
    errorMessage: 'Bitte Adresse eingeben'
  },
  XlineBreakB: {},
  zip_code: {
    tag: 'input',
    label: 'PLZ',
    attributes: {
      type: 'text',
      placeholder: 'PLZ',
      style: {width: '300px'}
    },
    errorMessage: 'Bitte Postleitzahl eingeben'
  },
  location: {
    tag: 'input',
    label: 'Ort',
    attributes: {
      type: 'text',
      placeholder: 'Ort',
      style: {width: '300px'}
    },
    errorMessage: 'Bitte Ort eingeben'
  },
  country: {
    tag: 'input',
    label: 'Land',
    value: 'Deutschland',
    attributes: {
      type: 'text',
      placeholder: 'Land',
      style: {width: '300px'}
    },
    errorMessage: 'Bitte Land eingeben'
  },
  XlineBreakD: {},
  phone: {
    tag: 'input',
    label: 'Telefonnummer für SMS',
    attributes: {
      type: 'text',
      placeholder: 'Telefon',
      style: {width: '300px'}
    },
    errorMessage: 'Bitte Telefonnummer eingeben'
  },
  XsmallskipA: {},
  notify_by_email: {
    tag: 'boxes',
    label: '',
    classname: 'JaNein',
    attributes: {
      type: 'checkbox',
      options: [{value: 'true', label: 'Ich möchte per Email kontaktiert werden.', className: 'transparentgreen'}],
      disabled: true
    }
  },
  XlineBreakE: {},
  notify_by_sms: {
    tag: 'boxes',
    label: '',
    classname: 'JaNein',
    attributes: {
      type: 'checkbox',
      options: [{value: 'false', label: 'Ich möchte per SMS kontaktiert werden, sobald dies möglich ist.', className: 'transparentgreen'}]
    }
  }
}

const ProfileForm = (props) => {
  const [msg, setMsg] = useState( null );
  const [errorMsg, setErrorMsg] = useState( null );
  const [smsEnabled, setSmsEnabled] = useState( false );
  const store = useSelector( state => state );
  const navigate = useNavigate();

  // @TODO: noch keine sehr elegante Loesung :(
  useEffect( () => {
    // const smsInput = document.getElementById('notify_by_sms');
    // const container = document.getElementById('container_notify_by_sms');
    // if (smsInput && container) {        
    //   smsInput.disabled = !smsEnabled;
    //   if( smsEnabled ) {
    //     container.style.opacity=1;
    //   } else {
    //     smsInput.checked = false;
    //     container.style.opacity=0.4;
    //   }
    // }
    const emailInput = document.getElementById('notify_by_email');
    const emailContainer = document.getElementById('container_notify_by_email');
    if (emailInput && emailContainer) {        
      emailInput.disabled = true;
      emailInput.checked = true;
      emailContainer.style.opacity=0.4;
    }
  });

  const fetchData = async() => {
    const token = getAuthToken();

    if ( token == null ) {
      return;
    }

    const cfg = API.auth_cfg( token );
    return API.req( `${API.entry}/profile.json`, 'get', {}, cfg )
    .then( data => { return data } )

  }

  const changeHandler = (key, value, valid) => {
    //setSmsEnabled( store.forms?.forms?.profile?.state?.phone.value?.length > 6 )
    const phoneField = document.getElementById('input_phone');
    if (phoneField) {
      setSmsEnabled( phoneField.value.length > 6 )
    }

    let smsInput = document.getElementById('notify_by_smsIchmöchteperSMSkontaktiertwerden.true');
    if (smsInput && store.forms?.forms?.profile?.state?.phone.value  === "" ) {
      smsInput.checked = false;
      smsInput.disabled = true;
    }
  } // changeHandler

  const submitHandler = async (event) => {
    event.preventDefault();

    const token = getAuthToken();

    if ( token == null ) {
      setMsg( 'Daten Absenden ist in der Demo nicht möglich.');
      return;
    }

    const profileData = FormGenerator.extractValuesFromStore( store.forms.forms.profile.state );

    const cfg = API.auth_cfg( token );
    const txData = { submitter: profileData }

    API.req( `${API.entry}/profile.json`, 'put', txData, cfg )
    .then((data) => {
      console.log("Submitted");
      if ( isFirstLogin() ) {
        clearFirstLogin();
        navigate('/submit/');
      } else {
        setMsg("Daten übermittelt");
      }
    })
    .catch( (err) => {
      console.log( err.message );
      setErrorMsg( err.message );
    });

  } // submitHandler
  

  return <>
    { msg && 
      <Modal show={!!msg}
        modalClosed={() => { setMsg(null) }}
        className = 'success'>
          <div>{msg}</div>
      </Modal>
    }
    { errorMsg && 
      <Modal show={!!errorMsg}
        modalClosed={() => { setErrorMsg(null) }}
        className = 'error'>
          <div>{errorMsg}</div>
      </Modal>
    }
    <ReduxForm  
      entries = {theForm}
      label = {formLabel}
      onChange={changeHandler}
      onSubmit = {submitHandler}
      submitButtonLabel = "Speichern"
      fetchData = {fetchData}
    />
  </>
};

export default ProfileForm;


/*
XlineBreakA: {},
notification_email: {
  tag: 'input',
  label: 'Email',
  attributes: {
    type: 'email',
    placeholder: 'E-Mail Adresse zur Benachrichtigung',
    style: {width: '300px'}
  },
  validation: {
    required: true,
  },
  errorMessage: 'Bitte gültige E-Mail Adresse eingeben'
},
notification_email_cc: {
  tag: 'input',
  label: 'Email',
  attributes: {
    type: 'email',
    placeholder: 'Weitere E-Mail Adresse zur Benachrichtigung',
    style: {width: '300px'}
  },
  errorMessage: 'Bitte gültige E-Mail Adresse eingeben'
},
XlineBreakB: {},
*/